import mod from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal-link.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal-link.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/modal-link/africa/modal-link.vue?vue&type=script&lang=js
// module id = OHay
// module chunks = 37